import { render } from "./MyApply.vue?vue&type=template&id=beb78124"
import script from "./MyApply.vue?vue&type=script&lang=js"
export * from "./MyApply.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__